import { render, staticRenderFns } from "./CandidateCourseConfirmedItem.vue?vue&type=template&id=24dd35b4&lang=pug&"
import script from "./CandidateCourseConfirmedItem.vue?vue&type=script&lang=js&"
export * from "./CandidateCourseConfirmedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports